import CIPBlackLogo from '../../assets/images/cip-icon-black.png';
import CipLogo from '../../assets/images/cip-icon-white.png';
import DTLogo from '../../assets/images/dt.svg';
import EPSLogo from '../../assets/images/eps.svg';
import ESLogo from '../../assets/images/es.svg';
import PAMLogo from '../../assets/images/pam.svg';
import PTLogo from '../../assets/images/pentester.svg';
import SATLogo from '../../assets/images/sat-icon.svg';
import SFSLogo from '../../assets/images/sfs.png';
import ZTNLogo from '../../assets/images/ztn.svg';

export const getApplicationLogo = (code, darkMode = null) => {
  let CIPLogo;

  if (darkMode) {
    CIPLogo = CipLogo;
  } else {
    CIPLogo = CIPBlackLogo;
  }

  let logo = null;

  if (code === 'DT') logo = DTLogo;
  if (code === 'EPS') logo = EPSLogo;
  if (code === 'AV') logo = EPSLogo;
  if (code === 'ES') logo = ESLogo;
  if (code === 'PAM') logo = PAMLogo;
  if (code === 'PP' || code === 'PT') logo = PTLogo;
  if (code === 'CIP') logo = CIPLogo;
  if (code === 'ZTN') logo = ZTNLogo;
  if (code === 'SFS') logo = SFSLogo;
  if (code === 'SAT') logo = SATLogo;

  return logo;
};

export const getUniqueNumber = () => new Date().getTime() + Math.random();
